import Appsignal from '@appsignal/javascript';
import config from 'config';

const appsignalInstance = new Appsignal({
  key: config.appSignal?.apiKey,
  revision: config.appSignal?.revision || 'development'
});

export default appsignalInstance;
